import { ApiBase } from './ApiBase';
class SaasApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getCurrentSubscription = () => {
            return this.get('/v1/saas/subscriptions/current');
        };
        this.getSubscriptionPlans = () => {
            return this.get('/v1/saas/shop/plans');
        };
        this.getDefaultSubscriptionPlan = () => {
            return this.get('/v1/saas/shop/plans/default');
        };
        this.createSubscriptionPlan = (payload) => {
            return this.post('/v1/saas/subscriptions', payload);
        };
        this.cancelSubscriptionPlan = () => {
            return this.post('/v1/saas/subscriptions/current/scheduled-cancellation');
        };
        this.undoCancelSubscriptionPlan = () => {
            return this.delete('/v1/saas/subscriptions/current/scheduled-cancellation');
        };
    }
}
export const SaasApiClient = new SaasApiClientModel();
